import React from 'react'; 
import PropTypes from 'prop-types';
import ResidentInfo, { ResidentInfoValidator } from './ResidentInfo';
import BusinessInfo, { BusinessInfoValidator } from './BusinessInfo';
import PhoneContact, { PhoneContactValidator } from './PhoneContact';
import SectionHeader from '../Basic/SectionHeader';
import IdType, { IdTypeValidation } from './CustomerDetails/Common/IdType';
export default class Account extends React.Component {
    render() {
        const p = this.props;
        let info = null;
         let idType = null;
        if (!p.bupaVerified)
            idType = <IdType name="idType" idType={p.idType} customerType={p.customerType} disabled={p.bupaCreated} />;
        switch (p.customerType) {
            case "1":
                info = <ResidentInfo name={p.name + "_residentInfo"} disabled={p.disableMainInfo} allowDOBEdit={p.allowDOBEdit} />;
                break;
            case "2":
            case "3":
                info = <BusinessInfo name={p.name + "_businessInfo"} disabled={p.disableMainInfo} allowDOBEdit={p.allowDOBEdit}/>;
                break;
        }
        let account = null;
        if(p.accountNo)
            account = 'We verified your account number <b>' + p.accountNo +'</b>';
        return (
            <div>
                <SectionHeader title={p.title} />
                {info}
                     {(p.verifyAccountRetriesExceed) ? null :
                                <div >
                                    {idType}                                                               
                                    <SectionHeader title={account} />   
                                     <br/>
                                </div>
                            }
                
                <PhoneContact name={p.name + "_phoneContact"} />
            </div>
        );
    }
}

Account.propTypes = {
    name: PropTypes.string.isRequired,
    customerType: PropTypes.string.isRequired,
    disableMainInfo: PropTypes.bool,
    title: PropTypes.string,
};

export function AccountValidation(name, form) {
    let toRet = [];
    switch (form.customerType) {
        case "1":
            toRet = [...ResidentInfoValidator(name + "_residentInfo")];
            break;
        case "2":
        case "3":
            toRet = [...BusinessInfoValidator(name + "_businessInfo")];
            break;
    }
    toRet = [...toRet,  ...IdTypeValidation("idType", form.idType, form.customerType, form.bupaVerified)];
    toRet = [...toRet, ...PhoneContactValidator(name + "_phoneContact")];
    return toRet;
}

